<template>
  <div class="full-screen">
    <!-- <map-new></map-new> -->
    <component :is="mapComponent"></component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const mapNew = () => import("./newMap/mapNew"); //  总览
const zzymap = () => import("./newMap/zzymap"); //  种植业
const xmymap = () => import("./newMap/xmymap"); //  畜牧业
const yymap = () => import("./newMap/yymap"); //  渔业
const ncmap = () => import("./newMap/ncmap"); //  农村
export default {
  components: {
    mapNew,
    zzymap,
    xmymap,
    yymap,
    ncmap
  },
  computed: {
    ...mapGetters(["mapComponent", "granaryIndex"])
  },
  watch: {
    granaryIndex: {
      handler(val) {
        this.updMap(val);
      },
      immediate: true
    }
  },
  mounted() {
    this.updMap(this.granaryIndex);
  },
  methods: {
    updMap(val) {
      //导航切换，修改地图加载
      if (val == 0) {
        this.$store.dispatch("map/setMapComponent", "mapNew");
      } else if (val == 1) {
        this.$store.dispatch("map/setMapComponent", "zzymap");
      } else if (val == 2) {
        this.$store.dispatch("map/setMapComponent", "xmymap");
      } else if (val == 3) {
        this.$store.dispatch("map/setMapComponent", "yymap");
      } else if (val == 4) {
        this.$store.dispatch("map/setMapComponent", "ncmap");
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.full-screen
    position fixed
    top 0
    bottom 0
    left 0
    right 0
</style>
